/**
 * EpgCtrl controller
 * Show all Epgs
 */

// controller mixins
EpgCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * EpgsCtrl controller
 *
 * @class EpgCtrl
 * @memberof mwApp/services
 * @see mwApp/services
 * @mixes mwApp/common.mixin:onOffCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/services.controller:EpgCtrl
 */
/* @ngInject */
export default function EpgCtrl ($scope, $uibModal, $timeout, Epg) {
  var vm = this

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true
  $scope.loadingER = []
  vm.isFound = true
  vm.epgs = []

  vm.erTableState = {}

  vm.executionResults = {
    OK: 'Ok',
    FAILED: 'Failed',
    CORRUPTED: 'Corrupted'
  }
  vm.scheduleTypes = {
    DAILY: 'Daily',
    HOURLY: 'Hourly',
    NEVER: 'Never',
    ONCE: 'Once'
  }

  /**
   * Epgs list
   *
   * @memberof mwApp/services.controller:EpgCtrl
   * @name vm.epgs
   * @type {models.Epg[]}
   */

  vm.getEpgs = function (tableState) {
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'name'
      tableState.sort.reverse = false
    }

    Epg.loadEPGS(tableState)
      .then(
        data => {
          vm.epgs = []
          if (data.content) {
            data.content.forEach(d => vm.epgs.push(new Epg(d)))
          }
          vm.isFound = !!vm.epgs.length
          for (let i = 0; i < tableState.pagination.totalItemCount; i++) {
            $scope.loadingER[i] = true
          }

          $scope.loading = false
        }
      )
  }

  /**
   * Run epg
   *
   * @memberof mwApp/services.controller:EpgCtrl
   * @param  {models.Epg} epg
   */
  vm.run = function (epg) {
    epg.loading = true
    epg._run()
      .then(
        function success () {
          const curEpg = { ...epg }
          $timeout(
            () => {
              // update task from server after 5 seconds
              epg._update()
                .finally(
                  () => {
                    epg.$executionResults = curEpg.$executionResults
                    vm.getER(epg)(vm.erTableState)
                    epg.loading = false
                  }
                )
            }, 5000
          )
        },
        function error () {
          vm.getER(epg)
          epg.loading = false
        }
      )
  }

  /**
   * Delete Epg
   *
   * @memberof mwApp/services.controller:EpgCtrl
   * @param  {models.Epg} epg
   */
  vm.deleteTask = function (epg) {
    epg._delete()
      .then(() => $scope.$broadcast('refreshTable'))
  }

  /**
   * Edit epg
   *
   * @memberof mwApp/services.controller:EpgCtrl
   * @function
   * @param  {models.Epg} epg
   */
  vm.editEpg = null

  /**
   * Create epg
   *
   * @memberof mwApp/services.controller:EpgCtrl
   * @function
   * @param  {models.Epg} epg
   * @param {Event} $event - jqLite event object
   */
  vm.addEpg = vm.editEpg = function (epg, $event) {
    vm.stopEvent($event)

    var isNew = !epg
    var initialEpg = angular.copy(epg) // initial state
    $uibModal.open({
      templateUrl: 'components/services/views/addEpg.html',
      controller: 'AddEpgCtrl as vm',
      animation: false,
      size: 'lg',
      resolve: {
        epg: function () {
          return !isNew
            ? epg
            : new Epg()
        }
      }
    }).result
      .then(
        function close (epg) {
          if (isNew) {
            vm.epgs.push(epg)
          }
        },
        function dismiss () {
          if (!isNew) {
            angular.copy(initialEpg, epg) // restore epg
          }
        }
      )
  }

  /**
   * Get DRM Profiles by account
   *
   * @memberof mwApp/settings.controller:DRMAccountsCtrl
   */
  vm.getER = (epg, index) => (tableState) => {
    $scope.loadingER[index] = true
    if (!epg.__open) {
      return
    }

    // set default sort by name
    if (!tableState.sort.predicate) {
      tableState.sort.predicate = 'name'
      tableState.sort.reverse = false
    }

    vm.erTableState = tableState

    Epg.loadER(tableState, { id: epg.id })
      .then(data => {
        epg.$executionResults = data.content
        $scope.loadingER[index] = false
      })
      .catch(() => {
        $scope.loadingER[index] = false
      })
  }
}
